import React, {Component} from 'react';
import ChangelogItem from './ChangelogItem';
import CustomPagination from '../../components/common/CustomPagination';

class ChangelogList extends React.Component {
    constructor(props) {
        super(props);
    }

    renderChanges() {
        let {changes} = this.props;
        if (!changes.length) {
            return 'Ingen ændringer...';
        }

        return (
            <div className="col-sm-12">
                {changes.map(change => <ChangelogItem key={change.id} change={change}/>)}
            </div>
        );
    }

    render() {
        let {
            total,
            page,
            onPageChange
        } = this.props;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        <h3 className="card-header m-0 bg-gray">Jeres seneste aktivitet</h3>
                        <div className="card-block">
                            <div className="row">
                                { this.renderChanges() }
                                <CustomPagination
                                    total={total}
                                    page={page}
                                    onPageChange={onPageChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangelogList;


// WEBPACK FOOTER //
// ./web/src/components/dashboard/ChangelogList.jsx